module.exports = __webpack_public_path__ + "static/media/record-icon.60da39a7.svg";